import React, { useState } from "react";
import Modal from "react-modal";
import styled from "styled-components";
import { CrossModal } from "./Icon/CrossModal";
const FIELD_MAP = {
  "Brand": (item) => item.brand,
  "Name": (item) => item.name,
  "Discontinued": (item) => item.discontinued,
  "Price Range": (item) => item.priceRange,
  "Attributes": (item) =>
    item.attributes?.map(a => a.name).join(", "),
  "Brand Retailer History": (item) =>
    item.brand_retailers?.map(b => b.name).join(", "),
  "Category": (item) =>
    item.categories?.map(c => c.name).join(", "),
  "Ingredients": (item) => item.ingredients,
  "Date Launched": (item) => item.date_launched,
  "Description": (item) => item.description,
};

const CsvModal = ({ isOpen, onClose, fields = [], data = [] }) => {
  const [selectedFields, setSelectedFields] = useState([]);

  const toggleField = (field) => {
    setSelectedFields((prev) =>
      prev.includes(field)
        ? prev.filter((f) => f !== field)
        : [...prev, field]
    );
  };

const buildCSV = () => {
  if (!selectedFields.length) return "";

  // keep fixed order from `fields`
  const orderedSelectedFields = fields.filter((field) =>
    selectedFields.includes(field)
  );

  const header = orderedSelectedFields.join(",");

  const rows = data.map((item) =>
    orderedSelectedFields
      .map((label) => {
        const resolver = FIELD_MAP[label];
        if (!resolver) return "";

        const value = resolver(item);

        if (value === null || value === undefined) return "";

        if (typeof value === "string") {
          return `"${value.replace(/"/g, '""')}"`;
        }

        return value;
      })
      .join(",")
  );

  return `${header}\n${rows.join("\n")}`;
};


  const handleDownload = () => {
    const csvString = buildCSV();
    if (!csvString) return;

    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "report.csv";
    a.click();

    URL.revokeObjectURL(url);
    setSelectedFields([]);
    onClose();
  };

  return (
    <Modal
               isOpen={isOpen}
               onRequestClose={()=>{setSelectedFields([]);onClose();}} 
               style={{
                   overlay: {  
                       backdropFilter: "blur(5px)", 
                       zIndex:1000,
                       backgroundColor: "rgba(255, 255, 255, 0.4)" 
                   }
                       ,
                   content: {
                       
                       top:'10%',
                       width: "30%",
                       height: "70%",
                       margin: "auto",
                       display: "flex",
                       flexDirection: "column",
                       gap:'90px',
                       background:'transparent',
                       border: "none",
                       
                       
                   }
               }}
           >
      
     <div style={{display:'flex',justifyContent:'flex-end'}}>
                 <button 
                     onClick={()=>{setSelectedFields([]);onClose();}} 
                     style={{
                         position: "absolute", 
                         width:56,
                         background:"rgba(255, 255, 255, 1)",
                         borderRadius:'64px',
                         height:56,
                         
                         border: "none", 
                        //  padding: "5px 10px",
                         cursor: "pointer",
                         
     
                     }}
                 >
                     <CrossModal/>
                 </button>
                 </div>
            <div style={{
                padding: "12px 32px",
                display:'flex',
                flexDirection:'column',
                justifyContent:'center',
                border: "none",
                borderRadius: "32px",
                boxShadow:' 0px 0px 40px 0.66px rgba(0, 0, 0, 0.06)',
                height:'80%',
                background: "rgba(255, 255, 255, 1)",
            }}>
      <Title>Select fields to include in .csv file</Title>

      <Options>
  {fields.map((field) => (
    <Option key={field}>
      <input
        type="checkbox"
        checked={selectedFields.includes(field)}
        onChange={() => toggleField(field)}
        style={{ cursor: "pointer" }}
      />
      <span>{field}</span>
    </Option>
  ))}
</Options>


      <DownloadBtn
        disabled={!selectedFields.length}
        onClick={handleDownload}
      >
        Download .csv
      </DownloadBtn>
      </div>
    </Modal>
  );
};

export default CsvModal;


const Title = styled.h3`
  margin: 0 0 24px;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  font-family:PPMori;
  color: #202327;
`;

const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  
  height: 65%;
  display: flex;
    flex-wrap: wrap;

  overflow-y: auto;
`;

const Option = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  color: #202327;
  font-family:PPMori;

`;

const DownloadBtn = styled.button`
  margin-top: 32px;
  align-self: center;
  height: 44px;
    width: 50%;
  border-radius: 100px;
  border: none;
  font-weight: 900;
  cursor: pointer;
  background: linear-gradient(90deg, #dcffad, #bddeff);
font-family:PPMori;
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;
